import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TourState {
  run: boolean;
  stepIndex: number;
  hasCompletedTour: boolean;
  startTour: () => void;
  stopTour: () => void;
  setStepIndex: (index: number) => void;
  completeTour: () => void;
}

export const useTourStore = create<TourState>()(
  persist(
    (set) => ({
      run: false,
      stepIndex: 0,
      hasCompletedTour: false,
      startTour: () => set({ run: true, stepIndex: 0 }),
      stopTour: () => set({ run: false }),
      setStepIndex: (index) => set({ stepIndex: index }),
      completeTour: () => set({ run: false, hasCompletedTour: true }),
    }),
    {
      name: 'product-tour-storage',
      partialize: (state) => ({ hasCompletedTour: state.hasCompletedTour }),
    }
  )
);
